import { AsyncPipe, CurrencyPipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { DateFormatPipe } from 'ngx-moment';
import { ItemService } from '../..';
import { Item } from '../../../models';
import { ItemAttachmentsComponent } from '../../item-attachments/item-attachments.component';
import { LocationNameFromIdPipe } from '../../pipes/location-name-from-id.pipe';
import { WorkshopJobHistoryListComponent } from '../../workshop-job-history-list/workshop-job-history-list.component';
import { HireHistoryTableComponent } from './hire-history-table/hire-history-table.component';
import { ItemSummaryTabComponent } from './item-summary-tab/item-summary-tab.component';
import { MatIconModule } from '@angular/material/icon';
import { ItemAttributesComponent } from '../../item-attributes/item-attributes.component';

@Component({
  templateUrl: './item-dialog.component.html',
  styleUrls: ['./item-dialog.component.css'],
  providers: [ItemService, DateFormatPipe, CurrencyPipe],
  standalone: true,
  imports: [
    MatTabsModule,
    MatDialogModule,
    WorkshopJobHistoryListComponent,
    ItemAttributesComponent,
    ItemAttachmentsComponent,
    MatTooltipModule,
    MatButton,
    HireHistoryTableComponent,
    ItemSummaryTabComponent,
    LocationNameFromIdPipe,
    AsyncPipe,
    MatIconModule
  ]
})
export class ItemDialogComponent {
  item: Item;

  unavailableReason = '';
  availableToHire = false;
  selectedTabIndex = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<ItemDialogComponent>,
    private itemService: ItemService,
    private router: Router
  ) {
    this.itemService.get(data.item.id, ['product']).subscribe((item) => {
      this.item = item;
      this.setUnavailableStatus();
    });
    this.router.events.subscribe(() => {
      this.dialogRef.close();
    });
  }

  goToProduct() {
    this.router.navigate(['/product/', this.item.product_id, { type: 'hire' }]);
  }

  hireItem() {
    this.dialogRef.close(true);
  }

  setUnavailableStatus() {
    if (
      this.item.status !== 'Available' &&
      this.item.has_current_workshop_jobs
    ) {
      this.unavailableReason =
        'This item is currently on hire and has outstanding workshop jobs';
    } else if (this.item.status !== 'Available') {
      this.unavailableReason = 'This item is currently on hire';
    } else if (this.item.has_current_workshop_jobs) {
      this.unavailableReason = 'This item has outstanding workshop jobs';
    } else if (this.item.deleted) {
      this.unavailableReason = 'This item has been disposed of';
    } else {
      this.availableToHire = true;
    }
  }

  setSelectedTab(tab: string) {
    if (tab === 'hires') {
      this.selectedTabIndex = 1;
    }
    if (tab === 'workshopJobs') {
      this.selectedTabIndex = 4;
    }
  }
}
